export function renum(o) {
  for (let k in o) {
    o[o[k]] = k;
  }
}
// http://mmtest.oa.com/codesearch/raw/mmgamecenter/src/svrkit/mmgamegift/result/result.proto
/*
enum RewardStatus {
  REWARD_STATUS_NOT_OPEN             = 1;  // 未拆开未领取
  REWARD_STATUS_NOT_RECEIVE          = 2;  // 已拆开未领取
  REWARD_STATUS_RECEIVE              = 3;  // 已拆开已领取（实物在这个状态：未填写地址）
  REWARD_STATUS_RECEIVE_WITH_ADDRESS = 4;  // 已拆开已领取已填地址（实物多一种这个状态：已填写地址）
}
*/
export const ButtonStatus = {
  STATUS_UNKNOWN: 0, // 未知状态
  STATUS_NOT_OPEN: 1, // 未拆开未领取
  STATUS_NOT_RECEIVED: 2, // 已拆开未领取
  STATUS_RECEIVED: 3, // 已拆开已领取（实物在这个状态：未填写地址）
  STATUS_RECEIVED_WITH_ADDRESS: 4, //已拆开已领取已填地址（实物多一种这个状态：已填写地址）
  STATUS_EXPIRESED: 700
};
export const SKButtonStatus = {
  STATUS_NOT_OPEN: 0, //未拆开未领取
  STATUS_NOT_RECEIVED: 1, //已拆开未领取
  STATUS_NOT_RECEIVE_HAS_CARD: 2, //已拆开已下发插卡参数未领取
  STATUS_RECEIVED: 3, //已拆开已领取
  STATUS_EXCHANGE: 4 //已领取未兑换  预约礼包
};
export const RewardStatus = {
  STATUS_NOT_RECEIVED: 1,
  STATUS_RECEIVED: 2,
  STATUS_EXPIRESED: 3
};

export const GameStatus = {
  STATUS_DOWNLOAD: 0, // 下载
  STATUS_YUYUE: 1, // 预约(调用预约的CGI)
  STATUS_GRAB: 3, // 抢号(YYB.PreemptiveUrl抢号)
  STATUS_SHIWAN: 4, // 试玩(展示为试玩，实际上还是下载)
  STATUS_UNDEFINED: 5 // 未定义（未使用状态，此状态下游戏不可下载，也不可预约）
  // STATUS_TIYAN        = 2,  // 体验(废弃）
  // STATUS_GOOGLEPLAY   = 10, // google play 下载(废弃)
};
export const ButtonDesc = {
  0: '领取',
  1: '领取',
  2: '领取',
  3: '填写收货地址',
  4: '查看收货地址',
  10: '已过期',
  700: '已过期'
};
export const SourceType = {
  TYPE_GIFT: 1, //礼包
  TYPE_CARD: 2, //卡券
  TYPE_CASH: 3, //现金
  TYPE_THING: 4, //实物
  TYPE_RED_PACKET: 5, //红包封面
  TYPE_APPOINTMENT_GIFT: 6, //预约礼包
  TYPE_MALL_COUPON: 7, //商城券
  TYPE_CDKEY: 8, // CDKEY
  TYPE_WXAG: 9, // 小游戏礼包
  TYPE_CUSTOM: 700,
  TYPE_ADS: 9999,
  TYPE_FEEDS: 10000,
  TYPE_1: '游戏道具',
  TYPE_2: '游戏道具',
  TYPE_3: '现金红包',
  TYPE_4: '实物奖励',
  TYPE_5: '红包封面',
  TYPE_6: '游戏道具',
  TYPE_7: '游戏道具',
  TYPE_8: 'CDKEY',
  TYPE_9: '小游戏礼包',
  TYPE_700: '自定义',
  TYPE_9999: '广告',
  TYPE_10000: '奖励列表'
};
export const RewardType = {
  TYPE_CASH: 1,
  TYPE_CARD: 2,
  TYPE_GIFT: 3,
  TYPE_THING: 4
};
//摇一摇结果事件配置
export const ShakeEvent = {
  EVENT_MY_WISH_HIGH: 1,
  EVENT_MY_WISH_MID: 2,
  EVENT_MY_WISH_LOW: 3,
  EVENT_FRIEND_WISH: 4,
  EVENT_SMALL_REWARD: 5,
  EVENT_REDPACKER_COVER: 6, //红包封皮
  EVENT_APPOINT_GIFT1: 7, //预约一级大礼包,珍贵,写入feed,摇一摇出
  EVENT_AD_PIC: 8,
  EVENT_AD_VEDIO: 9,
  EVENT_APPOINT_GIFT2: 10, //预约二级大礼包,摇一摇出
  EVENT_APPOINT_GIFT3: 11, //预约三级大礼包,摇一摇出
  EVENT_APPOINT_GIFT4: 12, //预约四级小礼包,摇一摇出
  EVENT_APPOINT_SMALL_GIFT: 20, //预约小礼包,点预约发放的固定礼包,不在摇一摇中出此事件,复用平台预约礼包
  EVENT_GLOBAL_WISH: 21, // 2021废弃
  EVENT_CASH_1: 22, // 2021废弃
  EVENT_CASH_2: 23, // 2021废弃
  EVENT_CASH_3: 24, // 2021废弃
  EVENT_CASH_4: 25, // 2021废弃
  EVENT_APPOINT_SMALL_CARD: 26, // 2021废弃
  EVENT_APPOINT_CARD: 27, // 2021废弃
  EVENT_1_HIGH: 15, //奖池1(普通奖池)高级奖励-表情雨
  EVENT_1_LOW: 16, //奖池1(普通奖池)低级奖励-表情雨
  EVENT_2_HIGH: 17, //奖池2(锦鲤奖池)高级奖励-表情雨
  EVENT_2_LOW: 18 //奖池2(锦鲤奖池)低级奖励-表情雨
};
export const UserSubscribeType = {
  USER_SUBSCRIBE_ACT_OPEN: 1, // 用户订阅活动开启
  USER_SUBSCRIBE_GLOBAL_WISH_OPEN: 2 // 用户订阅狂欢心愿开启
};
export const RESEVE_MAP = {
  reserve: 45,
  confirmWifi: 58
};
export const GAME_MAP = {
  launchApp: 6,
  download: 3
};
renum(ButtonStatus);
renum(SKButtonStatus);
renum(SourceType);
renum(RewardType);
renum(RewardStatus);
renum(GameStatus);
renum(ShakeEvent);
renum(UserSubscribeType);

export const ERRORS = {
  15789023: 'ERR_USER_NOT_REGIEST',
  ERR_USER_NOT_REGIEST: '注册游戏后才可领取',
  ERR_NO_REGIST: '注册游戏后才可领取',
  111981011: '注册游戏后才可领取',
  20100: '抱歉，未到卡券发放时间',
  20101: '抱歉，您已经领取过该卡券了',
  45033: '抱歉，您已经领取过该卡券了',
  20102: '抱歉，今日卡券已领完，请于明日再来',
  20103: '抱歉，卡券已经领完了',
  45031: '抱歉，卡券已经领完了',
  57000: '活动罢工了，快找管理员修理它',
  57001: '资源礼包还未到发放时间',
  57002: '资源礼包发放已经结束',
  57003: '今天已经领取过奖励咯~',
  57004: '本周领取奖励次数已达到上限咯~',
  57005: '领取奖励次数已达到上限，感谢参与~',
  57006: '今天活动奖励已经领完，请明天再来',
  57007: '本周活动奖励已经领完，请下周再来',
  57008: '奖励全部领完，请关注后续活动',
  57014: '活动罢工了，快找管理员修理它',
  57015: '你暂未达成领取条件',
  57016: '扣减领取次数出了点小问题，稍后再来试试吧~',
  57018: '今日已经领取过奖励咯~',
  57019: '本周领取奖励次数已达到上限咯~',
  57020: '领取次数已用完，感谢参与~',
  57021: '活动太火爆了，请稍后再试',
  57022: '商户号配置错误',
  57024: '此奖励仅限微信活跃老用户领取',
  57025: '此奖励已暂停发放',
  57026: '领取已达上限，感谢参与~',
  57027: '仅限专用测试账号领取',
  16103024: '游戏上线后无法领取预约礼包',
  180939239: '预约礼包已兑换,不可重复兑换',
  180939240: '很抱歉，预约礼包兑换失败',
  180939241: '很抱歉，预约礼包配置错误，暂无法兑换',
  180939242: '很抱歉，预约礼包兑换条件未知，暂无法兑换',
  180939245: '很抱歉，请注册游戏角色后兑换',
  180939246: '很抱歉，当前礼包仅支持首次从微信游戏中心下载的用户兑换哦',
  180939235: '很抱歉，当前礼包仅限本人领取，无法领取别人分享的哦',
  180939236: '礼包一定是走丢了，领取失败，请稍后再试',
  180939234: '这个礼包仅限首次在微信游戏中心下载的用户兑换哦',
  180939225: '很抱歉，预约礼包配置错误，请稍后再试', //获取资源配置失败
  180939226: '很抱歉，预约礼包配置错误，请稍后再试', //资源不存在
  180939227: '预约礼包未到兑换日期，详情查看领取说明', //资源已经过期
  180939228: '很抱歉，获取预约礼包记录失败，请稍后再试', //获取预约礼包用户记录失败
  180939229: '很抱歉，获取预约礼包记录失败，请稍后再试', //获取预约礼包用户记录失败
  180939230: '活动太火爆了，请稍后再试.', //获取appuin失败
  180939231: '活动太火爆了，请稍后再试..', //获取appid失败
  180939232: '活动太火爆了，请稍后再试...', //获取OpenID失败
  180939233: '活动太火爆了，请稍后再试....', //解析OpenID失败
  180939237: '活动太火爆了，请稍后再试~', //更新实例状态失败
  180939238: '活动太火爆了，请稍后再试~', //更新实例的状态跟要更新的状态一致
  180939243: '活动太火爆了，请稍后再试~', //加密异常
  180939244: '活动太火爆了，请稍后再试~', //解密异常
  180939247: '活动太火爆了，请稍后再试~', // 预约礼包类型异常
  180939248: '活动太火爆了，请稍后再试~', // 删除过期预约礼包异常
  112920033: '活动已结束，不能领取了哦',
  111981018: '当前领取人数较多，请稍后再试' //ERR_SEND_WXAG_FREQ_LIMIT 小游戏礼包兑换，达到频率限制
};

export const Config = {
  editAddress: true,
  actid: 20000001,
  share_icon:
    'https://mmgame.qpic.cn/image/4aa2570e9369246f981191c1df037045e2d57eb812f9b9bb19b0232e7798c583',
  cash_icon:
    'https://mmgame.qpic.cn/image/eabc704332336ee2466782999d0ec2132be5a744f0760d17f05810e044aa0b0c/0',
  wish_icon:
    'https://mmgame.qpic.cn/image/c1f9d1dfa1b793c6c67c02cace3230bf74490bb1486b594ee6ce651f31e15fcb/0',
  thing_icon:
    'https://res.wx.qq.com/wechatgame/product/webpack/userupload/20200917/233515/icon.png',
  default_head:
    'https://mmgame.qpic.cn/image/bcd31b1b715acd1d7d16fae1079fc229e8f2b3061bf4171695fc91966e863863/0',
  giftcenter: 'https://game.weixin.qq.com/cgi-bin/welfare/static/welfareone/index.html?nowepkg=1',
  qrcode:
    'https://mmgame.qpic.cn/image/ca90002a1020301d2081b3b133b5063353426da58878226ce4885b78335fb0c0/0',
  shareMap: { singlemessage: 1, groupmessage: 1, timeline: 1 },
  closeTimeout: 300,
  shake_icon:
    'https://mmgame.qpic.cn/image/c1f9d1dfa1b793c6c67c02cace3230bf74490bb1486b594ee6ce651f31e15fcb/0',
  shake_gift:
    'https://game.weixin.qq.com/cgi-bin/event/static/shake-festival/index.html?path=make_wish',
  shop_wish_list:
    'https://game.weixin.qq.com/cgi-bin/h5/static/autominiprogram/minigame.html?appid=wxda09e5b08eb5f65a&weapp=weapp%3A%2F%2Fwxda09e5b08eb5f65a%3Fpath%3Dpages%252Fmy-wish-list%252Findex.html%253Fminiapp_webview%253D1%2526ssid%253D1066043145%2526actid%253D20000001%2526is_shake_wish%253D1',
  ads_list: [
    {
      image_url:
        'https://mmgame.qpic.cn/image/81f2286be49480aa4658772be596793fe383edd331ae8a75f7b4e3b872ae179f/0',
      jump_url:
        'https://game.weixin.qq.com/cgi-bin/h5/static/autominiprogram/minigame.html?appid=wxda09e5b08eb5f65a&weapp=weapp%3A%2F%2Fwxda09e5b08eb5f65a%3Fpath%3Dpages%252Frebate-lottery-commodity%252Findex.html%253Fminiapp_webview%253D1%2526ssid%253D1066043145%2526actid%253D20000001%2526appid%253Dwx95a3a4d7c627e07d%2526dj_id%253D23876',
      title: '游市集'
    }
  ]
};
// darkmode, lightmode
export const Themes = {
  default: ['#b29641', '#ffd75e'],
  green: ['#1d7d49', '#1d7d49', '#0e3e24', '#1d7d49'],
  red: ['#ac2702', '#ac2702'],
  feedlist: ['#ffefd9', '#ffefd9']
};
export const Env = WXGAME.Env;

export const APP_TYPE = {
  DEFAULT: 0,
  MINI_GAME: 1,
  OUTSIDE: 2
};

export default {
  Env,
  ButtonDesc,
  SourceType,
  ButtonStatus,
  SKButtonStatus,
  RewardType,
  RewardStatus,
  ERRORS,
  Config,
  Themes,
  GameStatus,
  ShakeEvent,
  RESEVE_MAP,
  GAME_MAP,
  APP_TYPE
};
